import Phaser from 'phaser';
import { SCENES, COLORS } from '../config/gameConfig';

/**
 * BootScene - Initializes core systems and immediately transitions to PreloadScene
 * This scene handles any pre-loading setup that needs to happen before assets load.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.BOOT });
  }

  preload(): void {
    // Set background color
    this.cameras.main.setBackgroundColor(COLORS.BACKGROUND);
  }

  create(): void {
    // Initialize any core systems here
    // For now, immediately transition to preload
    this.scene.start(SCENES.PRELOAD);
  }
}
